import { ViewUtils } from "../../../util/view/ViewUtils";
import { GameErrorEvent } from "../../Constants";
import { TitanButton } from "../../control/TitanButton";
import { CommonLang } from "../lang/CommonLang";
import { MessageDialog } from "./MessageDialog";
/**
 * RealityCheckDialog.ts
 */
export class RealityCheckDialog extends MessageDialog {
    createProperties(properties) {
        super.createProperties(properties);
        this.properties = properties;
    }
    create() {
        super.create();
        this.name = "RealityCheckDialog";
        this.createWagerHistoryButton();
        this.createExitGameButton();
        this.createContinueButton();
        this.createWinField();
        this.createWageredField();
    }
    createConfirmButton() {
    }
    createTitleField() {
    }
    updateTitle() {
    }
    createWinField() {
        this.winField = ViewUtils.createField(this, this.properties.winFieldProperties);
    }
    createWageredField() {
        this.wageredField = ViewUtils.createField(this, this.properties.wageredFieldProperties);
    }
    createWagerHistoryButton() {
        this.wagerHistoryButton = new TitanButton(this.properties.wagerHistoryButtonProperties);
        this.wagerHistoryButton.name = "wagerHistoryButton";
        this.wagerHistoryButton.onClick(this.handleWagerHistoryButtonSelected, this);
        this.addChild(this.wagerHistoryButton);
    }
    createExitGameButton() {
        this.exitGameButton = new TitanButton(this.properties.exitGameButtonProperties);
        this.exitGameButton.name = "exitGameButton";
        this.exitGameButton.onClick(this.handleExitGameButtonSelected, this);
        this.addChild(this.exitGameButton);
    }
    createContinueButton() {
        this.continueButton = new TitanButton(this.properties.continueButtonProperties);
        this.continueButton.name = "continueButton";
        this.continueButton.onClick(this.handleContinueButtonSelected, this);
        this.addChild(this.continueButton);
    }
    handleWagerHistoryButtonSelected() {
        this.callDataHandler(RealityCheckDialog.WAGER_HISTORY);
        this.handleClose();
    }
    handleExitGameButtonSelected() {
        this.callDataHandler(RealityCheckDialog.EXIT_GAME);
        this.handleClose();
    }
    handleContinueButtonSelected() {
        this.handleClose();
    }
    update(data) {
        super.update(data);
        this.updateWinField();
        this.updateWageredField();
    }
    updateWinField() {
        let message = this.data.getLang(CommonLang.REALITY_CHECK_WIN);
        if (message) {
            this.winField.setText(message, true);
        }
    }
    updateWageredField() {
        let message = this.data.getLang(CommonLang.REALITY_CHECK_WAGERED);
        if (message) {
            this.wageredField.setText(message, true);
        }
    }
    handleClose() {
        super.handleClose();
        this.dispatchCore(GameErrorEvent.REALITY_CHECK_CLOSE);
    }
}
RealityCheckDialog.WAGER_HISTORY = "RealityCheckDialog.WAGER_HISTORY";
RealityCheckDialog.EXIT_GAME = "RealityCheckDialog.EXIT_GAME";
//# sourceMappingURL=RealityCheckDialog.js.map